import { Injectable } from "@angular/core";

import { Observable, from } from "rxjs";
import { AwsAuthService } from '@nx/auth';

@Injectable({
  providedIn: 'root'
})

export class UserSignedInResolver  {
  constructor(private AwsAuthService: AwsAuthService ) {}

  resolve():Observable<any>{
    return from(this.AwsAuthService.isUserLoggedIn());
  }
}
